import $ from 'jquery'

$(document).ready(initSliderImageGallery)

function initSliderImageGallery() {
  $('.js-slider-image-gallery').each(function () {
    const $track = $(this)
    if ($track.hasClass('slick-initialized')) return

    const id = $track.data('gallery')
    const $arrows = $('.js-slider-image-gallery-arrows[data-gallery="' + id + '"]')

    $track.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      appendArrows: $arrows.length ? $arrows : $track,
      prevArrow: '<button type="button" class="slick-prev slider-image-gallery__arrow slider-image-gallery__arrow--prev" aria-label="Previous image"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Previous image" focusable="false"><title>Previous image</title><path d="M8 4L15 11L8 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next slider-image-gallery__arrow slider-image-gallery__arrow--next" aria-label="Next image"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Next image" focusable="false"><title>Next image</title><path d="M8 4L15 11L8 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        { breakpoint: 960, settings: { slidesToShow: 2 } },
        { breakpoint: 500, settings: { slidesToShow: 1 } },
      ],
    })
  })
}
